"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSelf = getSelf;
function getSelf(self) {
    return self;
}
//# sourceMappingURL=getSelf.js.map